import { Component, OnInit, Input, OnChanges, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';

import { LoadingPanelService, LoadingPanelSettings } from '../shared/loading-panel/loading-panel.service';

import { ChartConfiguration, PieValue } from './models';
import { ChartService } from './services/chart.service';
import { ChartBase } from './chart-base';
import { DxResizableModule, DxPieChartModule } from 'devextreme-angular';
import { DxiSeriesModule, DxoLabelModule, DxoConnectorModule, DxoLegendModule, DxoSizeModule, DxoTooltipModule, DxoExportModule } from 'devextreme-angular/ui/nested';

@Component({
    templateUrl: './chart-pie.component.html',
    selector: 'ep-chart-pie',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [DxResizableModule, DxPieChartModule, DxiSeriesModule, DxoLabelModule, DxoConnectorModule, DxoLegendModule, DxoSizeModule, DxoTooltipModule, DxoExportModule]
})

export class ChartPieComponent extends ChartBase implements OnChanges {

    constructor(private router: Router, private loadingPanelService: LoadingPanelService, private chartService: ChartService) { super(); }

    @Input() chartConfiguration: ChartConfiguration;
    @Input() colorPalette: string;

    isLoading = false;
    valueFields: PieValue[] = [];

    currentWidth = 500;
    currentHeight = 500;

    ngOnChanges(changes: any) {
        if (changes.chartConfiguration && this.chartConfiguration) {
            this.loadData();
        }

        if (changes.colorPalette && Array.isArray(this.colorPalette)) {
            this.currentPalette = super.cleanColors(this.colorPalette);
        }
    }

    private loadData() {
        this.isLoading = true;
        this.chartService.getPieValues(this.chartConfiguration.ChartConfigurationId).then(result => {
            this.valueFields = result;
            this.isLoading = false;
        }).catch(() => { this.isLoading = false });
    }  
}
